import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

interface DeleteAssignmentButtonProps {
  assignmentName: string;
  onDelete: () => void;
  isLoading?: boolean;
  hasReadOnly?: boolean;
}

const DeleteAssignmentButton = ({
  assignmentName,
  onDelete,
  isLoading = false,
  hasReadOnly = false,
}: DeleteAssignmentButtonProps) => {
  const handleDelete = () => {
    confirmDialog({
      message: `Are you sure you want to delete "${assignmentName}"?`,
      header: "Delete Assignment",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      accept: onDelete,
      reject: () => {},
    });
  };

  return (
    <Button
      label={isLoading ? "Deleting..." : "Delete"}
      icon="pi pi-trash"
      iconPos="right"
      onClick={handleDelete}
      disabled={isLoading || hasReadOnly}
      loading={isLoading}
      severity="danger"
      outlined
      className="min-w-50"
    />
  );
};

export default DeleteAssignmentButton;
